import { JobTask, JobTaskData } from '@root/globalTypes';
import { format, isBefore, parseISO, startOfToday } from 'date-fns';
import { JobDay, JobDayStatus } from './types';

export const getJobDayKey = (day: Date) => format(day, 'yyyy-MM-dd');

const isDraftTask = (task: JobTask) => task.status === 'draft' || task.schedule?.status === 'draft';

const getJobDayStatus = (day: Date, tasks: JobTask[]): JobDayStatus => {
  if (tasks.length && tasks.every((task) => task.status === 'completed')) return 'completed';
  if (isBefore(day, startOfToday())) return 'overdue';
  if (tasks.length && tasks.every(isDraftTask)) return 'draft';
  return 'scheduled';
};

export const parseJobDays = (data: JobTaskData[]): JobDay[] =>
  data
    .map((el) => {
      const day = parseISO(el.date);
      return { ...el, day, key: getJobDayKey(day), status: getJobDayStatus(day, el.tasks) };
    })
    .sort((a, b) => a.day.getTime() - b.day.getTime());

export const getDefaultJobDayKey = (days: JobDay[]) =>
  (days.find((el) => el.status !== 'completed') || days.at(-1))?.key || '';
